import { withPending, withRejected, withFulFilled } from './commons';
import { FETCH_TENANTS } from '../actions/tenants';

// initial state
const INITIAL_STATE = {
  running: false,
  error: null,
  payload: [], // { id: null, nome: ''}
};

// executer
const execute = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case withPending(FETCH_TENANTS):
    return { ...state, running: true };
  case withRejected(FETCH_TENANTS):
    return { ...state, running: false, error: action.payload };
  case withFulFilled(FETCH_TENANTS):
    return { ...state, running: false, payload: action.payload.data };
  default:
    return state;
  }
};

export default execute;
